import React, { useState } from 'react';
import transformArrayToObject from '~/utils/transformArrayToObject';
import moment from 'moment';
import I18n from '~/i18n';

const PeoplesProv = React.createContext({
  data: {
    data: [],
    page: 0,
    totalCount: 0,
  },
  records: {},
  reports: {},
  setData: () => null,
  modifyData: () => null,
  deleteRecord: () => null,
  addReports: () => null,
  reportUntil: '',
  setRecords: () => null,
  selectorState: '',
  setSelectorState: () => null,
});

export function PeoplesProvider({ children }) {
  const [records, setRecords] = useState({});
  const [reportUntil, setReportUntil] = useState(moment('01/01/1970').format('YYYY-MM-DD'));
  const [selectorState, setSelectorState] = useState({uuid: '0d', name: I18n.t('event.date_filter.all_time'), q:0, u:'d'});
  const [data, setData] = useState({
    data: [],
    page: 0,
    totalCount: 0,
  });
  const [reports, setReports] = useState({});

  function addReports(newReport, key) {
    setReports({...reports, [key]: newReport});
  }

  function addRecords(newData) {
    setData({ ...data, ...newData });

    const newRecords = transformArrayToObject(newData.data);
    setRecords({...records, ...newRecords});

    return newData;
  }
  function delRecord(id) {
    const index = data.data.findIndex(r => r.id === id);

    if (index > -1) {
      data.data.splice(index, 1);
      setData({ ...data, data: [ ...data.data ] });
    }
  }

  return (
    <PeoplesProv.Provider
      value={{
        data,
        addRecords,
        delRecord,
        records,
        addReports,
        reports,
        reportUntil,
        setReportUntil,
        selectorState,
        setSelectorState
      }}
    >
      {children}
    </PeoplesProv.Provider>
  );
}

export default PeoplesProv;
